import { gql } from "graphql-request";

export const getQuotationWon = gql`
  query {
    getQuotationWon {
      id
    }
  }
`;
export const allProduct = gql`
  query {
    allProduct {
      id
      productName
    }
  }
`;
export const getproduct = gql`
  query getproduct($id: String!) {
    getProductdetail(id: $id) {
      productCost
    }
  }
`;
export const allCustomer = gql`
  query {
    allCustomer {
      id
      legalName
    }
  }
`;
export const getcustomer = gql`
  query getcustomer($id: String!) {
    getCustomerDetail(id: $id) {
      address1Line1
      address2Line1
    }
  }
`;
export const organistationname = gql`
  query organistationname($organisationname: String!) {
    getOrganisationname(organizationName: $organisationname) {
      id
      firstName
    }
  }
`;
export const getwinqoutation = gql`
  query getwinqoutation($id: String!) {
    getQuotationDetailGetById(id: $id) {
      customer

      billingAddress

      contactPerson

      subTotal

      totalTaxAmount

      amountAndTax

      totalAmount

      otherCharges

      discount

      discountPercentage

      quotationproductsSet {
        productName {
          id

          productName
        }

        SKU

        HSNNumber

        comments

        quantity

        rate

        productrate
      }
    }
  }
`;
export const createsalesorder = gql`
mutation createsalesorder($input:SalesOrderInput!){
  createSalesOrder(input:$input){
    success
    message
  }
}
`;
